import { render, staticRenderFns } from "./cSkillManager.vue?vue&type=template&id=4c82e654&scoped=true"
import script from "./cSkillManager.vue?vue&type=script&setup=true&lang=js"
export * from "./cSkillManager.vue?vue&type=script&setup=true&lang=js"
import style0 from "./cSkillManager.vue?vue&type=style&index=0&id=4c82e654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c82e654",
  null
  
)

export default component.exports